import { unsplash } from '@/lib/utils/img';

type Props = {
  /** Page title (suffix " · Uncharted Odyssey" is appended automatically). */
  title: string;
  /** Meta description. Keep under 160 chars. */
  description?: string;
  /** Unsplash photo id or full URL — used for og:image when this page is shared. */
  image?: string;
  /** og:type — defaults to "website". Use "article" for editorial pages. */
  type?: 'website' | 'article' | 'product' | 'profile';
};

/**
 * Per-route page meta. React 19 hoists rendered <title> and <meta> tags
 * into <head>, so this updates the browser tab title and bookmarks
 * on navigation. (Social crawlers without JS won't see these — those
 * rely on the static defaults in index.html.)
 */
export function PageMeta({ title, description, image, type = 'website' }: Props) {
  const fullTitle = title.includes('Uncharted Odyssey')
    ? title
    : `${title} · Uncharted Odyssey`;
  const ogImage = image
    ? image.startsWith('http') ? image : unsplash(image, { w: 1200 })
    : undefined;

  return (
    <>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:type" content={type} />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </>
  );
}
